import React from "react";
import useTableData from "../useTableData";
import ListViewCommon from "../ListViewCommon";
import {datetimeColorGradient} from "../../../support/colors";

const headers = [
    {"label": "Cislo", "caption": "Číslo", 'filter': 'string', 'textStyle': 'bold'},
    {"label": "Pristroje", "caption": "Prístroje", 'filter': 'string'},
    {"label": "Zakaznik", "caption": "Zákazník", 'filter': 'string'},
    {"label": "Typ_Zapozicky", "caption": "Typ", 'filter': 'string'},
    {"label": "Datum_Otvorenia", "caption": "Dátum Otvorenia", 'filter': 'dateRange'},
    {"label": "Datum_Uzavretia", "caption": "Dátum Uzavretia", 'filter': 'dateRange'},
    {"label": "Stav__Stav", "caption": "Stav", 'filter': 'string', 'textStyle': 'bold'},
    {"label": "Zmena_Stavu", "caption": "Zmena Stavu", 'filter': 'dateRange'},
]

function Loans(props) {
    const initialFilters = [
        {
            'label': 'Cislo',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Datum_Otvorenia_before',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Datum_Otvorenia_after',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Datum_Uzavretia_before',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Datum_Uzavretia_after',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Zmena_Stavu_before',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Zmena_Stavu_after',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Zakaznik',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Nadpis',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Objednavka',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Stav__Stav',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Typ_Zapozicky',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Initial',
        },
        {
            'label': 'Pristroje',
            'lookup': '_SNR',
            'value': '',
        },
        {
            'label': 'Produkty',
            'lookup': '',
            'value': '',
        },
    ]
    const baseUrl = '/loan/loans'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(data) {
        return data.map(entry => ({
            'Cislo': `/loans/loan/${entry.id}`
        }))
    }

    // function colorize() {
    //     const rows = document.getElementsByTagName("tr")
    //     const new_rows = Array.from(rows)
    //     new_rows.splice(0,2)
    //     new_rows.forEach((row, index) => {
    //         const stav = data[index].Stav
    //         if (stav !== null) {
    //             const color = colors.find(entry => entry["stav"] === stav)["farba"]
    //             row.style.backgroundColor = color
    //         }
    //     })
    // }

    function colorize() {
        // #TBD: Change from imperative to declarative
        const rows = document.getElementsByTagName("tr")
        const new_rows = Array.from(rows)
        new_rows.splice(0, 2) // Do not color table header
        new_rows.forEach((row, index) => {
            const stav = data[index].Stav
            const lastChange = data[index].Zmena_Stavu
            const stateCell = row.getElementsByTagName("td")[6]
            const stateChangeCell = row.getElementsByTagName("td")[7]
            if (stav !== null) {
                const colorState = stav["Farba"]
                stateCell.style.backgroundColor = colorState
            } else {
                stateCell.style.backgroundColor = "unset"
            }
            if (lastChange !== null && !stav["Uzavrety"]) {
                const colorChange = datetimeColorGradient(lastChange)
                stateChangeCell.style.backgroundColor = colorChange
            } else {
                stateChangeCell.style.backgroundColor = "unset"
            }
        })
    }

    React.useEffect(() => {
        colorize()
    }, [data]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <ListViewCommon baseUrlFrontend={`/loans/loan`}
                        noColorRows={true}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Zápožičky"}
        />
    )
}

export default Loans
